import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=1136a088&scoped=true"
import script from "./FaqCategory.vue?vue&type=script&lang=ts"
export * from "./FaqCategory.vue?vue&type=script&lang=ts"
import style0 from "./FaqCategory.vue?vue&type=style&index=0&id=1136a088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1136a088",
  null
  
)

export default component.exports